"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FloatingActionButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

require("./FloatingActionButton.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    button: {
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.grey['200']
      }
    },
    icon: {
      color: theme.palette.secondary.main
    }
  };
};

var FloatingActionButton = /*#__PURE__*/function (_React$Component) {
  _inherits(FloatingActionButton, _React$Component);

  var _super = _createSuper(FloatingActionButton);

  function FloatingActionButton() {
    var _this;

    _classCallCheck(this, FloatingActionButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showMenuOptions: false
    });

    _defineProperty(_assertThisInitialized(_this), "onButtonClick", function () {
      if (_this.props.hasMenu) {
        _this.setState({
          showMenuOptions: !_this.state.showMenuOptions
        });
      } else {
        _this.props.mainButtonAction();
      }
    });

    return _this;
  }

  _createClass(FloatingActionButton, [{
    key: "menuOptionsCompile",
    value: function menuOptionsCompile() {
      var _this2 = this;

      var _this$props = this.props,
          menuOptions = _this$props.menuOptions,
          classes = _this$props.classes;

      if (menuOptions.length > 0) {
        return menuOptions.map(function (option, index) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: index,
            className: "FloatingActionButton_menuOptionButton"
          }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
            title: option.title,
            placement: "left"
          }, /*#__PURE__*/_react["default"].createElement(_material.Fab, {
            className: classes.button,
            onClick: function onClick() {
              option.action();

              _this2.setState({
                showMenuOptions: false
              });
            }
          }, typeof option.icon === 'string' ? /*#__PURE__*/_react["default"].createElement(_material.Icon, {
            className: classes.icon
          }, option.icon) : option.icon)));
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      /* eslint-disable no-nested-ternary */
      var _this$props2 = this.props,
          mainButtonTitle = _this$props2.mainButtonTitle,
          mainIcon = _this$props2.mainIcon,
          menuOptions = _this$props2.menuOptions;
      var showMenuOptions = this.state.showMenuOptions;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "FloatingActionButton_overlay".concat(showMenuOptions ? 'Show' : 'Hide'),
        onClick: function onClick() {
          return _this3.setState({
            showMenuOptions: false
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "FloatingActionButton_container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "FloatingActionButton_mainButton"
      }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: mainButtonTitle || '',
        placement: "left"
      }, /*#__PURE__*/_react["default"].createElement(_material.Fab, {
        onClick: this.onButtonClick
      }, menuOptions.length > 0 && !mainIcon ? /*#__PURE__*/_react["default"].createElement(_material.Icon, {
        className: "FloatingActionButton_showMenu ".concat(showMenuOptions ? 'rotate' : ''),
        style: {
          fontSize: '34px'
        }
      }, "keyboard_arrow_up") : typeof mainIcon === 'string' ? /*#__PURE__*/_react["default"].createElement(_material.Icon, null, mainIcon) : mainIcon))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "FloatingActionButton_menuContainer".concat(showMenuOptions ? 'Show' : 'Hide')
      }, showMenuOptions && this.menuOptionsCompile())));
      /* eslint-enable no-nested-ternary */
    }
  }]);

  return FloatingActionButton;
}(_react["default"].Component);

exports.FloatingActionButton = FloatingActionButton;

_defineProperty(FloatingActionButton, "propTypes", {
  hasMenu: _propTypes["default"].bool.isRequired,
  mainButtonAction: (0, _reactRequiredIf["default"])(_propTypes["default"].func, function (props) {
    return !props.hasMenu;
  }),
  mainButtonTitle: (0, _reactRequiredIf["default"])(_propTypes["default"].string, function (props) {
    return !props.hasMenu;
  }),
  mainIcon: (0, _reactRequiredIf["default"])(_propTypes["default"].node, function (props) {
    return !props.hasMenu;
  }),
  menuOptions: (0, _reactRequiredIf["default"])(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string.isRequired,
    icon: _propTypes["default"].node.isRequired,
    action: _propTypes["default"].func.isRequired
  })), function (props) {
    return props.hasMenu;
  }),
  classes: _propTypes["default"].object.isRequired
});

_defineProperty(FloatingActionButton, "defaultProps", {
  menuOptions: []
});

var _default = (0, _styles.withStyles)(styles)(FloatingActionButton);

exports["default"] = _default;